import React from "react";
import PropTypes from "prop-types";

import { Wrapper, ButtonPrimary, ButtonSecondary } from "./Footer.styles";
import { UIModalConsumer } from "components/UI/Modal/Context";

const WorkItemFormFooter = ({
  sections,
  onSave,
  onCancel,
  onGenerateReport,
  canSave
}) => {
  return (
    <Wrapper>
      <ButtonPrimary
        id="generate-report"
        onClick={() => onGenerateReport(sections)}
        data-gen-report-btn
        disabled={!canSave}
      >
        Generate Report
      </ButtonPrimary>

      <ButtonSecondary
        id="saveFooter"
        onClick={() => onSave(sections)}
        disabled={!canSave}
        data-save-btn
      >
        Save
      </ButtonSecondary>

      <UIModalConsumer>
        {({ confirm }) => (
          <ButtonSecondary
            id="cancelFooter"
            data-cancel-btn
            onClick={() => {
              const result =
                !canSave || confirm("Are you sure you want to Cancel?");
              if (result) onCancel();
            }}
          >
            Cancel
          </ButtonSecondary>
        )}
      </UIModalConsumer>
    </Wrapper>
  );
};

WorkItemFormFooter.propTypes = {
  sections: PropTypes.any,
  canSave: PropTypes.bool.isRequired,
  onGenerateReport: PropTypes.func,
  onSave: PropTypes.func,
  onCancel: PropTypes.func
};

WorkItemFormFooter.defaultProps = {
  onSave: () => {},
  onCancel: () => {},
  onGenerateReport: () => {}
};

export default WorkItemFormFooter;
